// export interface UserInfo {
//   name?: string;
//   company?: string;
//   category?: { title?: string };
//   address?: string;
//   phone?: string;
//   marketer_email?: string;
//   marketer_phone?: string;
//   emergency_contact?: string;
//   avatar_url?: string;
//   On_call_need_to_know?: string;
//   api_token?: string;
//   [key: string]: unknown;
// }

// export interface DownloadedFile {
//   id: string;
//   title: string;
//   url: string;
//   downloadedAt: string;
//   file_type?: 'pdf' | 'excel';
// }

// const STORAGEKEY = {
//   userData: 'userData',
//   token: 'token',
//   downloads: 'downloads',
// } as const;

// const localStore = {
//   store_data: (key: string, data: unknown): boolean => {
//     if (typeof window === 'undefined') return false;

//     try {
//       localStorage.setItem(key, JSON.stringify(data));
//       return true;
//     } catch (err) {
//       console.error('localStorage store error:', err);
//       return false;
//     }
//   },

//   get_data: (key: string): unknown | null => {
//     if (typeof window === 'undefined') return null;

//     try {
//       const item = localStorage.getItem(key);

//       if (!item || item === "undefined" || item === "null") {
//         return null;
//       }

//       return JSON.parse(item);
//     } catch (err) {
//       console.error("localStorage parse error:", err);
//       localStorage.removeItem(key); // cleanup corrupted data
//       return null;
//     }
//   },

//   remove_data: (key: string): boolean => {
//     if (typeof window === 'undefined') return false;

//     localStorage.removeItem(key);
//     return true;
//   },

//   remove_all: (): boolean => {
//     if (typeof window === 'undefined') return false;

//     localStorage.clear();
//     return true;
//   },
// };

// export const setUserInfo = (data: UserInfo): boolean =>
//   localStore.store_data(STORAGEKEY.userData, data);

// export const getUserInfo = (): UserInfo =>
//   (localStore.get_data(STORAGEKEY.userData) as UserInfo) || {};

// export const setUserToken = (data: string): boolean =>
//   localStore.store_data(STORAGEKEY.token, data);

// export const getUserToken = (): string | false =>
//   localStore.get_data(STORAGEKEY.token) as string | false;

// export const logout = (): boolean => {
//   localStore.remove_data(STORAGEKEY.token);
//   return true;
// };

// /** Removes token and userData from localStorage (use with cookie clear on auth invalid/logout). */
// export const clearAuthData = (): void => {
//   localStore.remove_data(STORAGEKEY.token);
//   localStore.remove_data(STORAGEKEY.userData);
// };

// export const setDownloadFiles = (files: DownloadedFile[]): boolean => {
//   return localStore.store_data(STORAGEKEY.downloads, files);
// };

// export const getDownloadFiles = (): DownloadedFile[] => {
//   const data = localStore.get_data(STORAGEKEY.downloads);
//   return (data as DownloadedFile[]) || [];
// };

// export const addDownloadFile = (file: DownloadedFile): void => {
//   const existing = getDownloadFiles();

//   const filtered = existing.filter((f) => f.id !== file.id);

//   const updated = [file, ...filtered];

//   setDownloadFiles(updated);
// };


export interface UserInfo {
  name?: string;
  company?: string;
  category?: { title?: string };
  address?: string;
  phone?: string;
  marketer_email?: string;
  marketer_phone?: string;
  emergency_contact?: string;
  avatar_url?: string;
  On_call_need_to_know?: string;
  api_token?: string;
  [key: string]: unknown;
}

export interface DownloadedFile {
  id: string;
  title: string;
  url: string;
  downloadedAt: string;
  file_type?: 'pdf' | 'excel';
}

const STORAGEKEY = {
  userData: 'userData',
  token: 'token',
  downloads: 'downloads',
} as const;

const SESSION_KEY = {
  userData: 'imp_userData',
  token: 'imp_token',
} as const;

const localStore = {
  store_data: (key: string, data: unknown): boolean => {
    if (typeof window === 'undefined') return false;
    try {
      localStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch (err) {
      console.error('localStorage store error:', err);
      return false;
    }
  },

  get_data: (key: string): unknown | null => {
    if (typeof window === 'undefined') return null;
    try {
      const item = localStorage.getItem(key);
      if (!item || item === 'undefined' || item === 'null') return null;
      return JSON.parse(item);
    } catch (err) {
      console.error('localStorage parse error:', err);
      localStorage.removeItem(key);
      return null;
    }
  },

  remove_data: (key: string): boolean => {
    if (typeof window === 'undefined') return false;
    localStorage.removeItem(key);
    return true;
  },

  remove_all: (): boolean => {
    if (typeof window === 'undefined') return false;
    localStorage.clear();
    return true;
  },
};

const sessionStore = {
  store_data: (key: string, data: unknown): boolean => {
    if (typeof window === 'undefined') return false;
    try {
      sessionStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch (err) {
      console.error('sessionStorage store error:', err);
      return false;
    }
  },

  get_data: (key: string): unknown | null => {
    if (typeof window === 'undefined') return null;
    try {
      const item = sessionStorage.getItem(key);
      if (!item || item === 'undefined' || item === 'null') return null;
      return JSON.parse(item);
    } catch (err) {
      console.error('sessionStorage parse error:', err);
      sessionStorage.removeItem(key);
      return null;
    }
  },

  clear: (): void => {
    sessionStorage.removeItem(SESSION_KEY.userData);
    sessionStorage.removeItem(SESSION_KEY.token);
  },
};

export const setUserInfo = (data: UserInfo): boolean =>
  localStore.store_data(STORAGEKEY.userData, data);

export const getUserInfo = (): UserInfo =>
  (localStore.get_data(STORAGEKEY.userData) as UserInfo) || {};

export const setUserToken = (data: string): boolean =>
  localStore.store_data(STORAGEKEY.token, data);

export const getUserToken = (): string | false =>
  localStore.get_data(STORAGEKEY.token) as string | false;

export const logout = (): boolean => {
  localStore.remove_data(STORAGEKEY.token);
  return true;
};

export const clearAuthData = (): void => {
  localStore.remove_data(STORAGEKEY.token);
  localStore.remove_data(STORAGEKEY.userData);
};

export const setDownloadFiles = (files: DownloadedFile[]): boolean =>
  localStore.store_data(STORAGEKEY.downloads, files);

export const getDownloadFiles = (): DownloadedFile[] =>
  (localStore.get_data(STORAGEKEY.downloads) as DownloadedFile[]) || [];

export const addDownloadFile = (file: DownloadedFile): void => {
  const existing = getDownloadFiles();
  const filtered = existing.filter((f) => f.id !== file.id);
  setDownloadFiles([file, ...filtered]);
};

export const setImpersonationUserInfo = (data: UserInfo): boolean =>
  sessionStore.store_data(SESSION_KEY.userData, data);

export const getImpersonationUserInfo = (): UserInfo | null =>
  sessionStore.get_data(SESSION_KEY.userData) as UserInfo | null;

export const setImpersonationToken = (token: string): boolean =>
  sessionStore.store_data(SESSION_KEY.token, token);

export const getImpersonationToken = (): string | null =>
  sessionStore.get_data(SESSION_KEY.token) as string | null;

export const clearImpersonationData = (): void => sessionStore.clear();

export const getActiveUserInfo = (): UserInfo =>
  getImpersonationUserInfo() || getUserInfo();

export const getActiveToken = (): string | null =>
  getImpersonationToken() || (getUserToken() as string | null);